import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import RpmReadingsPanel, { useRpmReadings } from '../../landingscreen/patientcharts/tabs/rpm/RpmReadingsPanel';

/*
 * Tasks -> an RPM alert's readings (owner 10-13: "Yes" to the same chart as
 * Dashboard -> Chart -> RPM and the RPM module). It used to draw its own
 * BPP / WLM chart (rpm/tabs/rpmlinegraph: month-name labels, ISO times that
 * break on Safari) and its own table; it now hosts the shared
 * RpmReadingsPanel (BP / Pulse / Weight, period filter, toggles, "All
 * Readings History") fed by useRpmReadings: the same bpp-master / wlm-master
 * reads as before, only while the modal is open. The modal keeps its own
 * chrome and its one action, Close.
 */
const Alertsgraphs = ({ PatientID, isAlert, onClose }) => {
  const { rpmData, wlmData, isLoading } = useRpmReadings(isAlert ? PatientID : null);
  if (!isAlert) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50" data-testid="alert-readings-modal">
      <div className="bg-white rounded-xl w-[92%] lg:w-[70%] max-h-[92vh] overflow-y-auto relative flex flex-col">
        <div className="flex w-full justify-end p-2">
          <button type="button" onClick={onClose} aria-label="Close">
            <CloseIcon />
          </button>
        </div>
        <div className="px-6 pb-6">
          <RpmReadingsPanel rpmData={rpmData} wlmData={wlmData} isLoading={isLoading} />
        </div>
      </div>
    </div>
  );
};

export default Alertsgraphs;
